export default "__VITE_ASSET__Dr$5bZJn__"